import {useTranslation} from "react-i18next";
import "./Support.css"
import useAnimation from "../../utils/hooks/animate";
import {useEffect, useState} from "react";
import {NavLink as NavLinkR} from "reactstrap";
import ContactModal from "../../components/ContactModal";

export const Support = () => {
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("support")});
    }, [t]);

    const [showModal, setShowModal] = useState(false);

    return (
        <main className="pt-2">
            <section>
                <p className="text-center animated">{t('support.p.1')}</p>
                {/*<a target="_blank" rel="noreferrer" className="d-flex justify-content-center" href="https://t.me/Busines09575Bot">{t('telegram.bot')}</a>*/}
                <NavLinkR className="other d-flex justify-content-center link-primary" href=""
                          onClick={(e) => {
                              e.preventDefault();
                              setShowModal(true);
                          }}>
                    {t('contacts.form.open')}
                </NavLinkR>
                <ContactModal type={'SUPPORT'} show={showModal} onHide={() => setShowModal(false)}/>
                <p className="text-center animated">{t('support.p.2')}</p>
            </section>
        </main>
    );
};